<app-control-wrapper
  [control]="wrapperFc || fc"
  [errors]="errors"
  [helper]="helper"
  [errorsOverrideParams]="errorsOverrideParams"
  [isShowHelper]="showHelper"
>
  <label *ngIf="label" [for]="id" control-label [ngClass]="labelClass">
    {{ label | translate }}
    <i *ngIf="required" class="fa fa-asterisk form-required" aria-hidden="true"></i>
  </label>
  <div class="input-wrapper" control-wrapper [ngClass]="{ 'with-icon': isWithIcon }">
    <span class="calendar-icon" *ngIf="isWithIcon">
      <i class="fa fa-calendar"></i>
    </span>
    <input
      #inputElement
      type="text"
      class="form-control"
      [id]="id"
      [name]="name"
      bsDatepicker
      [bsConfig]="bsConfig"
      [ngClass]="{ 'with-icon': isWithIcon }"
      [maxDate]="maxDateFormatted"
      [minDate]="minDateFormatted"
      [placeholder]="placeholder ? (placeholder | translate) : ''"
      (click)="onClickDate(inputElement)"
      (onHidden)="onHidden()"
      [ngModel]="dateValue | date : dateInputFormat || 'MM/dd/yyyy'"
      [disabled]="isShowDisabled && fc.disabled"
      (ngModelChange)="onModelChange($event)"
    />
  </div>
  <ng-content custom-error select="[custom-error]"></ng-content>
</app-control-wrapper>
